import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import {
  toastErrorMessageStyle,
  getZinoDomainAppData,
  getApiCallHostPath,
  getApiCallImagePath
} from "../../utils/apiCallFunction";
import { getStorageItem } from "../../utils/storageFunction";
import { validateOtp } from "../../redux/userview/userviewaction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import loginPageImg from "../../Images/login_img.svg";

import axios from "axios";

import { ReactComponent as AngleLeft } from "../../Icons/angleLeft.svg";

const OTPScreen = () => {
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [email, setEmail] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [resendTimer, setResendTimer] = useState(60);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const resendIntervalRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authenticate, logincall, isMobileUserAgent } = useSelector((state) => state.userviewstore);

  const generateOtp = async () => {
    if (sendingOtp || !email.trim()) return;
    setSendingOtp(true);
    try {
      await axios.get(`${getApiCallHostPath()}/api/v1/login/otp/${encodeURIComponent(email)}`);
      setShowOtpScreen(true);
      startResendTimer();
    } catch (error) {
      toast.error(error?.response?.data?.message || "something went wrong", toastErrorMessageStyle());
    } finally {
      setSendingOtp(false);
    }
  };

  const generateNewOTP = async () => {
    try {
      await axios.get(`${getApiCallHostPath()}/api/v1/login/otp/${encodeURIComponent(email)}/resend`);
      startResendTimer();
    } catch (error) {
      toast.error(error?.response?.data?.message || "something went wrong", toastErrorMessageStyle());
    }
  };
  const verifyOTP = async () => {
    if (otpVerifying) return;
    if (otpValue.trim().length !== 6) {
      toast.error("Please enter the 6-digit OTP", toastErrorMessageStyle());
      return;
    }
    setOtpVerifying(true);
    try {
      await dispatch(validateOtp(email, otpValue));
    } catch (error) {
      toast.error(error?.response?.data?.message || "something went wrong", toastErrorMessageStyle());
    } finally {
      setOtpVerifying(false);
    }
  };

  const startResendTimer = () => {
    if (resendIntervalRef.current) {
      clearInterval(resendIntervalRef.current);
    }
    setResendTimer(60); // Reset timer to 60 seconds
    resendIntervalRef.current = setInterval(() => {
      setResendTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(resendIntervalRef.current);
          resendIntervalRef.current = null;
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    return () => {
      if (resendIntervalRef.current) {
        clearInterval(resendIntervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (authenticate && !logincall && getStorageItem("Zino_app_user")) {
      let path = getStorageItem("Zino_app_user_go_to");
      if (path) {
        path = path.split("/");
        path = `/${path[path.length - 1]}`;
      }
      navigate(path || "/noaccess");
    }
    document.title = `${getZinoDomainAppData()?.title || "Zino"} || Login`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticate, logincall]);

  return (
    <>
      {showOtpScreen ? (
        <>
          <span
            className="material-symbols-outlined back_container login_back_btn go-to-login-page"
            onClick={() => navigate("/login")}
          >
            <AngleLeft className="login-input-icon" />
            <p>Back to Login</p>
          </span>
          <div className={isMobileUserAgent ? "mobile_login_page_outer_wrap otp-login" : "login_page_outer_wrap"}>
            <div className="login_page_img_outer">
              <img
                className="login_page_img"
                src={
                  getZinoDomainAppData()?.login_image
                    ? `${getApiCallImagePath()}/api/v1/public/${getZinoDomainAppData()?.login_image}`
                    : loginPageImg
                }
                alt="login img"
              ></img>
            </div>
            <div className="login_outer_container">
              <div className="login_inner_container login_field">
                <div className="app_form_item ">
                  <p className="zino_label otp_sent_message">
                    We've sent a one-time password to <span className="email_highlight">{email}</span>
                  </p>
                  <input
                    className="app_inputBox"
                    placeholder="Enter OTP"
                    value={otpValue}
                    onChange={({ target: { value } }) => setOtpValue(value)}
                    maxLength={6}
                  />
                </div>
                <div className="otp_sent_field_button_container login_field">
                  <button
                    className="app_btn_primary login"
                    onClick={verifyOTP}
                    disabled={otpVerifying || otpValue.trim().length !== 6}
                  >
                    {otpVerifying ? (
                      <div className="dots-loader">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                    ) : (
                      "Log in"
                    )}
                  </button>
                  <p className="otp_resend_label app_label">
                    Didn't receive the OTP?{" "}
                    {resendTimer === 0 ? (
                      <span className="otp_resend_link" onClick={generateNewOTP}>
                        Resend
                      </span>
                    ) : (
                      <span className="otp_resend_timer">
                        Resend in{" "}
                        {resendTimer === 60 ? "01:00" : `00:${resendTimer < 10 ? `0${resendTimer}` : resendTimer}`}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <span
            className="material-symbols-outlined back_container login_back_btn go-to-login-page"
            onClick={() => navigate("/login")}
          >
            {/* <span className="material-symbols-outlined" style={{ color: "#10182b" }}>
              chevron_left
            </span> */}
            <AngleLeft className="login-input-icon" />
            <p>Back to Login</p>
          </span>
          <div className={isMobileUserAgent ? "mobile_login_page_outer_wrap otp-login" : "login_page_outer_wrap"}>
            <div className="login_page_img_outer">
              <img
                className="login_page_img"
                src={
                  getZinoDomainAppData()?.login_image
                    ? `${getApiCallImagePath()}/api/v1/public/${getZinoDomainAppData()?.login_image}`
                    : loginPageImg
                }
                alt="login img"
              ></img>
            </div>
            <div className="login_outer_container">
              <div className="login_inner_container login_field">
                <div className="app_form_item">
                  <p className="zino_label">Enter your email to get an OTP</p>
                  <input
                    type="email"
                    placeholder="Enter email"
                    className="app_inputBox"
                    value={email}
                    onChange={({ target: { value } }) => setEmail(value)}
                  />
                </div>
                <button
                  className="app_btn_primary login"
                  onClick={generateOtp}
                  disabled={sendingOtp || !email.trim()}
                >
                  {sendingOtp ? (
                    <div className="dots-loader">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  ) : (
                    "Send OTP"
                  )}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default OTPScreen;
